import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import Accordion from '@mui/joy/Accordion';
import AccordionGroup from '@mui/joy/AccordionGroup';
import AccordionSummary from '@mui/joy/AccordionSummary';
import AccordionDetails from '@mui/joy/AccordionDetails';
import Typography from '@mui/joy/Typography';


import InfoItem from 'components/InfoItem';

import { InfoType } from 'stores/info_store';
import pluralize from 'utils/pluralize';
import getIcon from 'utils/getIcon';

import useUserIdentity from 'hooks/useUserIdentity';
import useInfo from 'hooks/useInfo';

const SidebarInfo = observer(({parent_type, parent_uuid}: { parent_type: string, parent_uuid: string}) => {
    const { fetchListByParent, items } = useInfo();
    const { currentIdentity } = useUserIdentity();
    const [fetched, setFetched] = useState(false);
    const [parentUuid, setParentUuid] = useState(parent_uuid);
    const [ourItems, setOurItems] = useState([] as InfoType[]);
    const InfoIcon = getIcon('InfoOutlined');
    useEffect(() => {

        if(!currentIdentity.uuid)
            return;
        if(fetched)
            return;
        setFetched(true);
        fetchListByParent(currentIdentity.uuid, parent_type, parent_uuid);
    }, [fetchListByParent, currentIdentity.uuid, fetched]);

    useEffect(() => {
        if(parent_uuid !== parentUuid) {
            setParentUuid(parent_uuid);
            setFetched(false);
        }
    }, [parent_uuid]);

    useEffect(() => {
        if(items.length > 0) {
            setOurItems(items.filter((item) => item.parent_uuid === parentUuid));
        }
    }, [items, parentUuid]);

    if(ourItems.length === 0)
        return null;
    return (
        <AccordionGroup size="lg">
            <Accordion>
                <AccordionSummary>
                    <InfoIcon />

                    <Typography level="body-sm">
                        {pluralize(ourItems?.length, 'bit') + ' of info'}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {ourItems.map((info) => (
                        <InfoItem key={info.uuid} info={info} />
                    ))}
                </AccordionDetails>
            </Accordion>
        </AccordionGroup>

    );
});

export default SidebarInfo;
